import { render, staticRenderFns } from "./v-select-enhanced.vue?vue&type=template&id=52c5685e&scoped=true&"
import script from "./v-select-enhanced.vue?vue&type=script&lang=js&"
export * from "./v-select-enhanced.vue?vue&type=script&lang=js&"
import style0 from "./v-select-enhanced.vue?vue&type=style&index=0&id=52c5685e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c5685e",
  null
  
)

export default component.exports